import { resolveResponsiveProp } from './responsiveProp';
import { resolveSpacing } from './space';
export const flex = (props) => {
    const { $flex, $direction, $wrap, $flow, $justifyContent, $alignItems, $alignContent, $gap, $columnGap, $rowGap, } = props;
    return `
    ${$flex ? `display: flex;` : ''}
    ${$direction
        ? resolveResponsiveProp($direction, (value) => `flex-direction: ${value};`)
        : ''}
    ${$wrap ? `flex-wrap: ${$wrap};` : ''}
    ${$flow ? `flex-flow: ${$flow};` : ''}
    ${$justifyContent
        ? resolveResponsiveProp($justifyContent, (value) => `justify-content: ${value};`)
        : ''}
    ${$alignItems
        ? resolveResponsiveProp($alignItems, (value) => `align-items: ${value};`)
        : ''}
    ${$alignContent
        ? resolveResponsiveProp($alignContent, (value) => `align-content: ${value};`)
        : ''}
    ${$gap
        ? resolveResponsiveProp($gap, (value) => `gap: ${resolveSpacing(value)};`)
        : ''}
    ${$columnGap
        ? resolveResponsiveProp($columnGap, (value) => `column-gap: ${resolveSpacing(value)};`)
        : ''}
    ${$rowGap
        ? resolveResponsiveProp($rowGap, (value) => `row-gap: ${resolveSpacing(value)};`)
        : ''}
  `;
};
//# sourceMappingURL=flex.js.map